export const formatDuration = (duration) => {
    let res = '';

    if (duration >= 0) {
        duration = duration / 1000 / 1000;
        // eslint-disable-next-line radix
        let hour = parseInt(duration / 3600);
        if (hour < 10) {
            hour = `0${hour}`;
        }
        // eslint-disable-next-line radix
        let minute = parseInt((duration % 3600) / 60);
        if (minute < 10) {
            minute = `0${minute}`;
        }
        let second = Math.ceil(duration % 60);
        if (second < 10) {
            second = `0${second}`;
        }
        res = `${hour}:${minute}:${second}`;
    }
    return res;
};
